import { Injectable } from '@angular/core';
import * as d3 from 'd3';
import { ScatterPlotSamplePoint } from './ScatterPlotSamplePoint';

@Injectable()
export class D3ExampleDataService {

  constructor() { }

  public RandomLearnMatrixSames(sampleCount: number) {
      const data = [];
      const random = d3.randomNormal();

      for (let i = 0; i < sampleCount; i++) {
          data.push(new ScatterPlotSamplePoint(
          'Thing ' + i.toString(),
            'This is something I need to learn.',
            random() * 5,
             random() * 5,
             this.DomainSwitch(i)
            ));
      }
      return data;
  }
  DomainSwitch(index: number): string  { 
    let v = '';
    switch (index % 4) {
     case 1: {
      v = 'Cognitive';
      break;
     }
     case 2: {
      v = 'Affective';
      break;
     }
     case 3: {
      v = 'Kinesthetic';
      break;
     }
     case 0: {
      v = 'Supportive';
      break;
     }
    }
    return v;
  } 
}
